import React, { useEffect, useState } from "react";
import "./LandingPage.css";
import { useLocation } from "react-router-dom"; // Import useLocation from react-router-dom
import { toast, ToastContainer } from "react-toastify";
import { useDispatch } from "react-redux";
import dinoLogo from "../media/Dino-Logo.webp";
import ImageModal from "./components/imageModal/ImageModal";
import Accordian from "./components/Accordian/Accordian";
import axios from "axios";
import MobileOrder from "./components/MobileOrder/MobileOrder";
import { Modal } from "react-bootstrap";
import { Calendar } from "react-multi-date-picker";
import { addItemsToCart } from "../redux/actions/cartAction";
import {
  eventInitDates,
  formatDateToDDMMYYYY,
  formatTimeToHHMM,
  getTotalPrice,
} from "../utils/utils";

export default function LandingPage() {
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const message = queryParams.get("message");
  const navbarHeight = 95;

  const [eventData, setEventData] = useState({});
  const [cartItems, setCartItems] = useState([]);
  const [isFixed, setIsFixed] = useState(false);

  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    setWidth(window.innerWidth);
  }, []);

  useEffect(() => {
    const totalQuantity = cartItems.reduce(
      (sum, item) => sum + item.orderQty,
      0
    );
    setBtnDisabled(totalQuantity === 0);
  }, [cartItems]);

  useEffect(() => {
    const handleScroll = () => {
      const boxRight = document.querySelector(".inner_box");
      const boxRightPosition = boxRight.getBoundingClientRect().top;

      if (boxRightPosition - navbarHeight <= 0) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}events/`)
      .then((response) => {
        setEventData(response.data[0]);
        const newTicketsArray = response.data[0].tickets.map((ticket) => ({
          ...ticket,
          orderQty: 0,
        }));
        setCartItems(newTicketsArray);
      })
      .catch((error) => {
        console.error("Error fetching events:", error);
      });
  }, []);

  const [showToast, setShowToast] = useState(false);

  const [isMobile, setIsMobile] = useState(false);

  const [btnDisabled, setBtnDisabled] = useState(false);

  // useEffect(() => {
  //   const tickets = JSON.parse(localStorage.getItem("cartTickets"));
  //   const event = JSON.parse(localStorage.getItem("cartEvent"));
  //   if (tickets || event) {
  //     setBtnDisabled(true);
  //   }
  // }, []);

  const [eventDates, setEventDates] = useState(eventInitDates);

  useEffect(() => {
    const currentDate = new Date(); // Get the current date

    const futureDates = eventInitDates.filter((date) => {
      const eventDate = new Date(date.id);
      return eventDate > currentDate;
    });
    setEventDates(futureDates);
  }, []);

  const [selectedDate, setSelectedDate] = useState();
  const [calendarSelectedDate, setCalendarSelectedDate] = useState(
    selectedDate ? selectedDate.id : "2024/03/01"
  );

  const [tempCalendarSelectedDate, setTempCalendarSelectedDate] =
    useState(calendarSelectedDate);
  const [calendarModalShow, setCalendarModalShow] = useState(false);

  const [modalImageUrl, setModalImageUrl] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (imageUrl) => {
    setModalImageUrl(imageUrl);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const weekDays = ["S", "M", "T", "W", "T", "F", "S"];

  const handleIncrement = (index) => {
    const updatedCart = [...cartItems];
    updatedCart[index].orderQty += 1;
    setCartItems(updatedCart);
  };

  const handleDecrement = (index) => {
    if (cartItems[index].orderQty > 0) {
      const updatedCart = [...cartItems];
      updatedCart[index].orderQty -= 1;
      setCartItems(updatedCart);
    }
  };

  useEffect(() => {
    if (message) {
      setShowToast(true);
    }
  }, [message]);

  useEffect(() => {
    if (showToast) {
      const toastStyle =
        message === "Email verification failed." ? "error" : "success";

      toast[toastStyle](message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      setShowToast(false); // Hide the toast after displaying it
    }
  }, [showToast, message]);

  const handleAddToCart = () => {
    if (!selectedDate) {
      toast.error("Please select a date");
      return;
    }
    const itemsWithQuantity = cartItems.filter((item) => item.orderQty > 0);

    dispatch(addItemsToCart(itemsWithQuantity, eventData, selectedDate));
    setBtnDisabled(true);
  };

  const slicedEventDates =
    width > 768
      ? eventDates.slice(0, 4)
      : width > 576 && width <= 768
      ? eventDates.slice(0, 3)
      : eventDates.slice(0, 2);

  if (!eventData) {
    return <p>...</p>;
  }

  return (
    eventData && (
      <>
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <div className="hero">
          <div className="hero_inner_box">
            <img src={eventData.banner} alt="event" />
          </div>
        </div>
        <div className="content">
          <div className="inner_box">
            <div className="left_box">
              <div className="event_title_box mb-4">
                <p className="text-start">Dinosaurs Event, Be On A Date !</p>
              </div>
              <div className="event_oraganizer_box">
                <div className="event_organizer_img">
                  <img src={dinoLogo} alt="dino_logo" />
                </div>
                <div className="event_organizer_name text-start">
                  <p>{`${eventData.organizer?.firstname} ${eventData.organizer?.lastname}`}</p>
                  <>
                    <svg
                      width="19"
                      height="18"
                      viewBox="0 0 19 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.5 0L11.6329 6.56434H18.535L12.9511 10.6213L15.084 17.1857L9.5 13.1287L3.91604 17.1857L6.04892 10.6213L0.464963 6.56434H7.36712L9.5 0Z"
                        fill="#FFC700"
                      />
                    </svg>
                    <svg
                      width="19"
                      height="18"
                      viewBox="0 0 19 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.5 0L11.6329 6.56434H18.535L12.9511 10.6213L15.084 17.1857L9.5 13.1287L3.91604 17.1857L6.04892 10.6213L0.464963 6.56434H7.36712L9.5 0Z"
                        fill="#FFC700"
                      />
                    </svg>
                    <svg
                      width="19"
                      height="18"
                      viewBox="0 0 19 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.5 0L11.6329 6.56434H18.535L12.9511 10.6213L15.084 17.1857L9.5 13.1287L3.91604 17.1857L6.04892 10.6213L0.464963 6.56434H7.36712L9.5 0Z"
                        fill="#FFC700"
                      />
                    </svg>
                    <svg
                      width="19"
                      height="18"
                      viewBox="0 0 19 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.5 0L11.6329 6.56434H18.535L12.9511 10.6213L15.084 17.1857L9.5 13.1287L3.91604 17.1857L6.04892 10.6213L0.464963 6.56434H7.36712L9.5 0Z"
                        fill="#FFC700"
                      />
                    </svg>
                    <svg
                      width="19"
                      height="18"
                      viewBox="0 0 19 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.5 0L11.6329 6.56434H18.535L12.9511 10.6213L15.084 17.1857L9.5 13.1287L3.91604 17.1857L6.04892 10.6213L0.464963 6.56434H7.36712L9.5 0Z"
                        fill="#FFC700"
                      />
                    </svg>
                  </>
                </div>
              </div>
              <div className="inner_tickets_box">
                <div className="tickets_box">
                  <div className="icon">
                    <svg
                      width="33"
                      height="32"
                      viewBox="0 0 33 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_298_6725)">
                        <path
                          d="M11.3697 4.41378V24.6737C9.9165 23.077 7.49395 22.716 5.61315 23.8157C3.73262 24.9156 2.9314 27.1616 3.70956 29.1532C4.48744 31.1446 6.62245 32.3122 8.78246 31.9275C10.9425 31.5428 12.5102 29.7157 12.5077 27.5862V9.65515L28.4387 5.79309V20.2599C26.9854 18.6632 24.5629 18.3022 22.6821 19.4019C20.8016 20.5018 20.0003 22.7478 20.7785 24.7394C21.5564 26.7308 23.6914 27.8984 25.8514 27.5137C28.0114 27.129 29.5791 25.3019 29.5766 23.1724V0L11.3697 4.41378Z"
                          fill="#57BEC0"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_298_6725">
                          <rect width="33" height="32" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <h1>{eventData.eventCategory}</h1>
                </div>
                <div className="tickets_box">
                  <div className="icon" id="clock">
                    <svg
                      width="29"
                      height="29"
                      viewBox="0 0 29 29"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.5007 0C8.70953 0 3.99805 4.71148 3.99805 10.5026C3.99805 17.6897 13.3969 28.2406 13.7971 28.6863C14.173 29.1049 14.8292 29.1042 15.2044 28.6863C15.6046 28.2406 25.0034 17.6897 25.0034 10.5026C25.0033 4.71148 20.2919 0 14.5007 0ZM14.5007 15.7868C11.587 15.7868 9.21663 13.4164 9.21663 10.5026C9.21663 7.58894 11.5871 5.21853 14.5007 5.21853C17.4144 5.21853 19.7848 7.58899 19.7848 10.5027C19.7848 13.4164 17.4144 15.7868 14.5007 15.7868Z"
                        fill="#64C3C5"
                      />
                    </svg>
                  </div>
                  <h1>{eventData.city}</h1>
                  <h6>more details</h6>
                </div>
                <div className="tickets_box">
                  <div className="icon">
                    <svg
                      width="34"
                      height="34"
                      viewBox="0 0 34 34"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M11.3333 1.41675C12.1157 1.41675 12.75 2.05102 12.75 2.83341V4.25008H21.25V2.83341C21.25 2.05102 21.8842 1.41675 22.6667 1.41675C23.4491 1.41675 24.0833 2.05102 24.0833 2.83341V4.25012C24.7337 4.25052 25.3005 4.25452 25.7761 4.29339C26.3361 4.33918 26.8927 4.44025 27.4287 4.7133C28.2268 5.11999 28.8789 5.76909 29.287 6.57031C29.56 7.10608 29.661 7.66292 29.7068 8.22236C29.75 8.75246 29.75 9.39584 29.75 10.1411V23.8597C29.75 24.605 29.75 25.2481 29.7068 25.778C29.661 26.3373 29.56 26.8938 29.287 27.4294C28.8793 28.2299 28.2277 28.8801 27.4287 29.2871C26.893 29.5601 26.3365 29.6611 25.7772 29.7069C25.2474 29.7501 24.6042 29.7501 23.8589 29.7501H10.1411C9.39576 29.7501 8.75238 29.7501 8.22229 29.7069C7.66284 29.6611 7.106 29.5601 6.57023 29.2871C5.76975 28.8793 5.12027 28.2283 4.71322 27.4294C4.44013 26.8934 4.33908 26.3365 4.29331 25.7765C4.24996 25.2459 4.24997 24.6018 4.25 23.855V10.1458C4.24997 9.39896 4.24996 8.75459 4.29331 8.2238C4.33905 7.66371 4.44006 7.10642 4.71322 6.57031C5.12069 5.77062 5.77054 5.12076 6.57023 4.7133C7.10636 4.44014 7.66363 4.33913 8.22374 4.29339C8.69945 4.25453 9.26645 4.25052 9.91667 4.25012V2.83341C9.91667 2.05102 10.5509 1.41675 11.3333 1.41675ZM8.45439 7.11732C8.06926 7.14877 7.92649 7.20217 7.85654 7.23782C7.58998 7.37365 7.37357 7.59006 7.23775 7.85662C7.20209 7.92657 7.1487 8.06934 7.11724 8.45446C7.08841 8.80753 7.08407 9.25797 7.08343 9.91675H26.9165C26.916 9.25699 26.9117 8.80628 26.8828 8.45313C26.8514 8.06876 26.7981 7.92633 26.7625 7.85662C26.6275 7.59159 26.4105 7.37443 26.1423 7.23782C26.0722 7.20205 25.9295 7.14872 25.5452 7.1173C25.1441 7.08452 24.6171 7.08341 23.8003 7.08341H10.2003C9.38351 7.08341 8.85595 7.08452 8.45439 7.11732ZM26.9167 12.7501H7.08334V23.8004C7.08334 24.6172 7.08444 25.1444 7.11724 25.5457C7.14867 25.9303 7.20202 26.073 7.23775 26.1431C7.37398 26.4104 7.59077 26.6272 7.85654 26.7626C7.92625 26.7982 8.06868 26.8514 8.45305 26.8829C8.85389 26.9156 9.3804 26.9167 10.1956 26.9167H23.8044C24.6197 26.9167 25.1458 26.9156 25.5463 26.8829C25.9301 26.8514 26.0725 26.7983 26.1423 26.7626C26.4096 26.6265 26.6271 26.4089 26.7625 26.1431C26.7982 26.0733 26.8515 25.9309 26.8828 25.5471C26.9155 25.1466 26.9167 24.6203 26.9167 23.8052V12.7501ZM9.91667 17.0001C9.91667 16.2177 10.5509 15.5834 11.3333 15.5834H11.3362C11.7176 15.5834 12.083 15.7373 12.3495 16.0101C12.6161 16.283 12.7614 16.6519 12.7525 17.0332L12.7524 17.0361C12.7436 17.4118 12.5859 17.7686 12.3139 18.028C12.0419 18.2874 11.678 18.4282 11.3022 18.4192H11.2994C10.5305 18.4007 9.91667 17.772 9.91667 17.0029V17.0001ZM15.5833 17.0001C15.5833 16.2177 16.2176 15.5834 17 15.5834H17.0028C17.3843 15.5834 17.7497 15.7373 18.0162 16.0101C18.2828 16.283 18.428 16.6519 18.4191 17.0332V17.0361C18.4103 17.4118 18.2525 17.7686 17.9805 18.028C17.7086 18.2874 17.3447 18.4282 16.9688 18.4192H16.9661C16.1972 18.4007 15.5833 17.772 15.5833 17.0029V17.0001ZM21.25 17.0001C21.25 16.2177 21.8842 15.5834 22.6667 15.5834H22.6695C23.4518 15.5834 24.0862 16.2177 24.0862 17.0001V17.0029C24.0862 17.3846 23.9322 17.7499 23.6592 18.0165C23.3861 18.2832 23.017 18.4284 22.6355 18.4192H22.6328C21.8638 18.4007 21.25 17.772 21.25 17.0029V17.0001ZM9.91667 22.6667C9.91667 21.8843 10.5509 21.2501 11.3333 21.2501H11.3362C11.7176 21.2501 12.083 21.4039 12.3495 21.6768C12.6161 21.9496 12.7614 22.3185 12.7525 22.6999L12.7524 22.7027C12.7436 23.0784 12.5859 23.4353 12.3139 23.6947C12.0419 23.9541 11.678 24.0949 11.3022 24.0858H11.2994C10.5305 24.0674 9.91667 23.4387 9.91667 22.6696V22.6667ZM15.5833 22.6667C15.5833 21.8843 16.2176 21.2501 17 21.2501H17.0028C17.3843 21.2501 17.7497 21.4039 18.0162 21.6768C18.2828 21.9496 18.428 22.3185 18.4191 22.6999V22.7027C18.4103 23.0784 18.2525 23.4353 17.9805 23.6947C17.7086 23.9541 17.3447 24.0949 16.9688 24.0858H16.9661C16.1972 24.0674 15.5833 23.4387 15.5833 22.6696V22.6667ZM21.25 22.6667C21.25 21.8843 21.8842 21.2501 22.6667 21.2501H22.6695C23.051 21.2501 23.4164 21.4039 23.6828 21.6768C23.9495 21.9496 24.0947 22.3185 24.0857 22.6999V22.7027C24.077 23.0784 23.9191 23.4353 23.6471 23.6947C23.3753 23.9541 23.0113 24.0949 22.6355 24.0858H22.6328C21.8638 24.0674 21.25 23.4387 21.25 22.6696V22.6667Z"
                        fill="#64C3C5"
                      />
                    </svg>
                  </div>
                  <h1>{formatDateToDDMMYYYY(eventData.startDate)}</h1>
                </div>
                <div className="tickets_box" id="clock">
                  <div className="icon" id="clock">
                    <svg
                      width="34"
                      height="34"
                      viewBox="0 0 34 34"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_298_6707)">
                        <path
                          d="M28.1675 4.83277C25.051 1.71633 20.9071 0 16.5 0C12.0929 0 7.94896 1.71633 4.83252 4.83277C1.71608 7.94921 0 12.0926 0 16.5C0 20.9074 1.71608 25.0508 4.83252 28.1672C7.94896 31.2837 12.0929 33 16.5 33C20.9071 33 25.051 31.2837 28.1675 28.1672C31.2839 25.0508 33 20.9074 33 16.5C33 12.0926 31.2839 7.94921 28.1675 4.83277ZM16.5 30.2264C8.93145 30.2264 2.77332 24.0688 2.77332 16.5C2.77332 8.9312 8.93145 2.77365 16.5 2.77365C24.0686 2.77365 30.2267 8.9312 30.2267 16.5C30.2267 24.0688 24.0686 30.2264 16.5 30.2264Z"
                          fill="#64C3C5"
                        />
                        <path
                          d="M11.4507 25.2617C10.9188 24.9548 10.2381 25.1366 9.93015 25.6685C9.62333 26.2011 9.80591 26.8818 10.3378 27.1888C10.5128 27.2902 10.7046 27.3385 10.8935 27.3385C11.2778 27.3385 11.6515 27.1389 11.8579 26.7821C12.1651 26.2494 11.9831 25.5688 11.4507 25.2617Z"
                          fill="#64C3C5"
                        />
                        <path
                          d="M10.8736 7.90013C11.0632 7.90013 11.2558 7.85178 11.4316 7.74981C11.9627 7.44126 12.1439 6.75981 11.8351 6.22868C11.5259 5.69688 10.8453 5.51645 10.314 5.82492C9.78222 6.13347 9.60187 6.81418 9.91051 7.34597C10.117 7.70147 10.4898 7.90013 10.8736 7.90013Z"
                          fill="#64C3C5"
                        />
                        <path
                          d="M6.2154 11.8646C6.39039 11.965 6.58154 12.0135 6.7703 12.0135C7.15483 12.0135 7.52938 11.814 7.73505 11.4563C8.04204 10.9245 7.8593 10.2438 7.32742 9.93685C6.79488 9.62912 6.11426 9.81178 5.80719 10.3442C5.50013 10.8769 5.68295 11.5569 6.2154 11.8646Z"
                          fill="#64C3C5"
                        />
                        <path
                          d="M16.48 6.38967C16.4809 6.38967 16.4809 6.38967 16.4814 6.38967C17.0962 6.3881 17.5935 5.88931 17.593 5.2746C17.5912 4.65981 17.0927 4.16258 16.4778 4.16407C15.8629 4.16481 15.3658 4.66369 15.3672 5.27831C15.3679 5.89236 15.8659 6.38967 16.48 6.38967Z"
                          fill="#64C3C5"
                        />
                        <path
                          d="M6.22484 21.1593C5.69296 21.467 5.51179 22.1476 5.82051 22.6797C6.027 23.0356 6.40073 23.2346 6.78452 23.2346C6.97402 23.2346 7.16575 23.1862 7.34164 23.0842C7.87344 22.7765 8.05444 22.0949 7.74589 21.5638C7.43742 21.032 6.75663 20.8506 6.22484 21.1593Z"
                          fill="#64C3C5"
                        />
                        <path
                          d="M6.38958 16.5117C6.38876 15.8969 5.88996 15.3997 5.27534 15.4004C4.66063 15.4011 4.16332 15.8999 4.16406 16.5139C4.16489 17.1287 4.66286 17.6259 5.27691 17.6259H5.27748C5.89244 17.6252 6.39041 17.1263 6.38958 16.5117Z"
                          fill="#64C3C5"
                        />
                        <path
                          d="M16.5046 26.6104C15.8908 26.6112 15.3926 27.1092 15.3926 27.7239C15.3934 28.3386 15.8916 28.8367 16.5062 28.8359C17.1209 28.8359 17.6191 28.337 17.6183 27.7223C17.6183 27.1083 17.1197 26.6104 16.5046 26.6104Z"
                          fill="#64C3C5"
                        />
                        <path
                          d="M26.7793 21.1477C26.2476 20.8401 25.5671 21.0218 25.259 21.5537C24.9514 22.0855 25.1332 22.7662 25.665 23.074C25.8409 23.1754 26.0326 23.2236 26.2213 23.2236C26.6059 23.2236 26.9796 23.0249 27.1853 22.668C27.4931 22.1362 27.3111 21.4554 26.7793 21.1477Z"
                          fill="#64C3C5"
                        />
                        <path
                          d="M27.7217 15.3611C27.1071 15.3627 26.6097 15.8623 26.6113 16.4769C26.6113 16.4831 26.6113 16.4893 26.6113 16.4946C26.6113 16.4969 26.6113 16.4984 26.6113 16.5C26.6113 17.1147 27.1092 17.6128 27.7239 17.6128C28.3388 17.6128 28.8368 17.1147 28.8368 16.5C28.8368 16.4961 28.8368 16.4915 28.8368 16.487C28.8368 16.4823 28.8368 16.4769 28.8368 16.4716C28.8354 15.8569 28.3363 15.3603 27.7217 15.3611Z"
                          fill="#64C3C5"
                        />
                        <path
                          d="M21.5377 7.73208C21.7125 7.83339 21.9038 7.88091 22.0924 7.88091C22.477 7.88091 22.8515 7.68143 23.0572 7.32379C23.3643 6.79109 23.1815 6.11046 22.649 5.80348C22.1163 5.49724 21.4355 5.67989 21.1293 6.2126C20.8225 6.74513 21.0051 7.42592 21.5377 7.73208Z"
                          fill="#64C3C5"
                        />
                        <path
                          d="M21.5573 25.2566C21.0255 25.5642 20.8438 26.2448 21.1522 26.7768C21.3586 27.1328 21.7322 27.3323 22.1161 27.3323C22.3057 27.3323 22.4968 27.284 22.6724 27.1822C23.2043 26.8745 23.3855 26.1937 23.0779 25.6616C22.7699 25.1298 22.0891 24.9479 21.5573 25.2566Z"
                          fill="#64C3C5"
                        />
                        <path
                          d="M26.2096 11.9805C26.4 11.9805 26.5917 11.9313 26.7682 11.8292C27.2994 11.52 27.4798 10.8392 27.1705 10.3082C26.862 9.77632 26.1804 9.59672 25.6494 9.90527C25.1182 10.2137 24.9378 10.8952 25.2465 11.4263C25.453 11.7816 25.8259 11.9805 26.2096 11.9805Z"
                          fill="#64C3C5"
                        />
                        <path
                          d="M23.4923 17.28L17.6487 16.8815L17.0654 8.32261C17.0453 8.02817 16.8004 7.79956 16.5052 7.79956C16.21 7.79956 15.9654 8.02817 15.9451 8.32261L15.3722 16.7262L14.4369 16.6625C14.3121 16.6539 14.1895 16.6975 14.0981 16.7829C14.007 16.8682 13.9551 16.9877 13.9551 17.1127V18.3479C13.9551 18.4731 14.007 18.5924 14.0981 18.6777C14.182 18.756 14.2923 18.7993 14.4063 18.7993C14.4163 18.7993 14.4266 18.799 14.4369 18.7983L15.2347 18.7438L15.1771 19.5861C15.1667 19.7413 15.2209 19.8937 15.327 20.0072C15.4331 20.1209 15.5816 20.1855 15.7372 20.1855H17.2732C17.2739 20.1855 17.2746 20.1855 17.275 20.1855C17.5848 20.1855 17.8361 19.9342 17.8361 19.6241C17.8361 19.5968 17.7643 18.571 17.7643 18.571L23.4926 18.1805C23.7294 18.1643 23.9134 17.9675 23.9134 17.7302C23.9129 17.493 23.7292 17.2962 23.4923 17.28Z"
                          fill="#64C3C5"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_298_6707">
                          <rect width="33" height="33" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <h1>{formatTimeToHHMM(eventData.startTime)}</h1>
                  <h6>4 Hours</h6>
                </div>
              </div>
              <div className="inner_media_box mt-5">
                <h1>Select date :</h1>
                <div className="home_divider_lg"></div>
                <div className="home_divider_sm"></div>
                <div className="home_event_dates_box px-4 py-5">
                  <div className="_selected_date">
                    <p>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8 1C8.55229 1 9 1.44772 9 2V3H15V2C15 1.44772 15.4477 1 16 1C16.5523 1 17 1.44772 17 2V3.00003C17.4591 3.00031 17.8592 3.00313 18.1949 3.03057C18.5902 3.06289 18.9831 3.13424 19.3614 3.32698C19.9248 3.61405 20.3851 4.07224 20.6732 4.63781C20.8659 5.016 20.9372 5.40906 20.9695 5.80396C21 6.17815 21 6.6323 21 7.15839V16.8421C21 17.3682 21 17.8221 20.9695 18.1962C20.9372 18.591 20.8659 18.9838 20.6732 19.3619C20.3854 19.9269 19.9254 20.3859 19.3614 20.6732C18.9833 20.8659 18.5905 20.9372 18.1957 20.9695C17.8217 21 17.3677 21 16.8416 21H7.15839C6.6323 21 6.17815 21 5.80397 20.9695C5.40906 20.9372 5.016 20.8659 4.63781 20.6732C4.07276 20.3853 3.61431 19.9258 3.32698 19.3619C3.13421 18.9835 3.06288 18.5904 3.03057 18.1951C2.99997 17.8206 2.99998 17.3659 3 16.8388V7.16168C2.99998 6.6345 2.99997 6.17965 3.03057 5.80498C3.06286 5.40962 3.13416 5.01624 3.32698 4.63781C3.6146 4.07332 4.07332 3.6146 4.63781 3.32698C5.01625 3.13416 5.40962 3.06286 5.80499 3.03057C6.14079 3.00314 6.54102 3.00031 7 3.00003V2C7 1.44772 7.44772 1 8 1ZM5.9678 5.02393C5.69595 5.04613 5.59517 5.08383 5.54579 5.10899C5.35763 5.20487 5.20487 5.35763 5.109 5.54579C5.08383 5.59517 5.04614 5.69595 5.02393 5.9678C5.00358 6.21702 5.00052 6.53498 5.00007 7H18.9999C18.9995 6.53429 18.9965 6.21614 18.9761 5.96686C18.9539 5.69554 18.9163 5.595 18.8912 5.54579C18.7959 5.35871 18.6427 5.20542 18.4534 5.10899C18.4039 5.08374 18.3032 5.0461 18.0319 5.02392C17.7488 5.00078 17.3768 5 16.8002 5H7.2002C6.62365 5 6.25126 5.00078 5.9678 5.02393ZM19 9H5V16.8002C5 17.3768 5.00078 17.7489 5.02393 18.0322C5.04612 18.3037 5.08378 18.4044 5.109 18.4539C5.20516 18.6426 5.35819 18.7956 5.54579 18.8912C5.595 18.9163 5.69554 18.9539 5.96686 18.9761C6.2498 18.9992 6.62146 19 7.19691 19H16.8031C17.3786 19 17.75 18.9992 18.0327 18.9761C18.3036 18.9539 18.4041 18.9164 18.4534 18.8912C18.6421 18.7951 18.7956 18.6415 18.8912 18.4539C18.9164 18.4046 18.954 18.3041 18.9761 18.0332C18.9992 17.7505 19 17.379 19 16.8036V9ZM7 12C7 11.4477 7.44772 11 8 11H8.002C8.27127 11 8.52916 11.1086 8.71732 11.3012C8.90548 11.4938 9.00802 11.7542 9.00173 12.0234L9.00168 12.0254C8.99548 12.2906 8.88414 12.5425 8.69215 12.7256C8.50016 12.9087 8.24327 13.0081 7.97804 13.0017H7.97608C7.43327 12.9887 7 12.5449 7 12.002V12ZM11 12C11 11.4477 11.4477 11 12 11H12.002C12.2713 11 12.5292 11.1086 12.7173 11.3012C12.9055 11.4938 13.008 11.7542 13.0017 12.0234V12.0254C12.9955 12.2906 12.8841 12.5425 12.6921 12.7256C12.5002 12.9087 12.2433 13.0081 11.978 13.0017H11.9761C11.4333 12.9887 11 12.5449 11 12.002V12ZM15 12C15 11.4477 15.4477 11 16 11H16.002C16.5542 11 17.002 11.4477 17.002 12V12.002C17.002 12.2714 16.8933 12.5293 16.7006 12.7175C16.5078 12.9057 16.2473 13.0082 15.978 13.0017H15.9761C15.4333 12.9887 15 12.5449 15 12.002V12ZM7 16C7 15.4477 7.44772 15 8 15H8.002C8.27127 15 8.52916 15.1086 8.71732 15.3012C8.90548 15.4938 9.00802 15.7542 9.00173 16.0234L9.00168 16.0254C8.99548 16.2906 8.88414 16.5425 8.69215 16.7256C8.50016 16.9087 8.24327 17.0081 7.97804 17.0017H7.97608C7.43327 16.9887 7 16.5449 7 16.002V16ZM11 16C11 15.4477 11.4477 15 12 15H12.002C12.2713 15 12.5292 15.1086 12.7173 15.3012C12.9055 15.4938 13.008 15.7542 13.0017 16.0234V16.0254C12.9955 16.2906 12.8841 16.5425 12.6921 16.7256C12.5002 16.9087 12.2433 17.0081 11.978 17.0017H11.9761C11.4333 16.9887 11 16.5449 11 16.002V16ZM15 16C15 15.4477 15.4477 15 16 15H16.002C16.2713 15 16.5292 15.1086 16.7173 15.3012C16.9055 15.4938 17.008 15.7542 17.0017 16.0234V16.0254C16.9955 16.2906 16.8841 16.5425 16.6921 16.7256C16.5002 16.9087 16.2433 17.0081 15.978 17.0017H15.9761C15.4333 16.9887 15 16.5449 15 16.002V16Z"
                          fill="#444790"
                        />
                      </svg>{" "}
                      {selectedDate
                        ? `${selectedDate.weekDay}, ${selectedDate.month} ${selectedDate.day}`
                        : "Select Date"}
                    </p>
                    <p>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_423_3707)">
                          <path
                            d="M17.0712 2.92895C15.1825 1.0402 12.6709 0 10 0C7.32905 0 4.81755 1.0402 2.9288 2.92895C1.04005 4.8177 0 7.32885 0 10C0 12.6712 1.04005 15.1823 2.9288 17.0711C4.81755 18.9598 7.32905 20 10 20C12.6709 20 15.1825 18.9598 17.0712 17.0711C18.96 15.1823 20 12.6712 20 10C20 7.32885 18.96 4.8177 17.0712 2.92895ZM10 18.319C5.413 18.319 1.6808 14.5871 1.6808 10C1.6808 5.41285 5.413 1.681 10 1.681C14.587 1.681 18.3192 5.41285 18.3192 10C18.3192 14.5871 14.587 18.319 10 18.319Z"
                            fill="#444790"
                          />
                          <path
                            d="M6.94008 15.3102C6.61773 15.1242 6.20518 15.2343 6.01853 15.5567C5.83258 15.8795 5.94323 16.2921 6.26558 16.4781C6.37168 16.5396 6.48788 16.5688 6.60238 16.5688C6.83528 16.5688 7.06178 16.4479 7.18688 16.2316C7.37303 15.9088 7.26273 15.4963 6.94008 15.3102Z"
                            fill="#444790"
                          />
                          <path
                            d="M6.59028 4.7879C6.70518 4.7879 6.82188 4.7586 6.92848 4.6968C7.25033 4.5098 7.36013 4.0968 7.17303 3.7749C6.98558 3.4526 6.57313 3.34325 6.25113 3.5302C5.92883 3.7172 5.81953 4.12975 6.00658 4.45205C6.13173 4.6675 6.35768 4.7879 6.59028 4.7879Z"
                            fill="#444790"
                          />
                          <path
                            d="M3.76702 7.1907C3.87307 7.25155 3.98892 7.2809 4.10332 7.2809C4.33637 7.2809 4.56337 7.16 4.68802 6.94325C4.87407 6.62095 4.76332 6.2084 4.44097 6.02235C4.11822 5.83585 3.70572 5.94655 3.51962 6.26925C3.33352 6.5921 3.44432 7.0042 3.76702 7.1907Z"
                            fill="#444790"
                          />
                          <path
                            d="M9.98848 3.87255C9.98898 3.87255 9.98898 3.87255 9.98933 3.87255C10.3619 3.8716 10.6633 3.5693 10.663 3.19675C10.6619 2.82415 10.3598 2.5228 9.98713 2.5237C9.61448 2.52415 9.31318 2.8265 9.31403 3.199C9.31448 3.57115 9.61628 3.87255 9.98848 3.87255Z"
                            fill="#444790"
                          />
                          <path
                            d="M3.77302 12.8238C3.45067 13.0103 3.34087 13.4227 3.52797 13.7452C3.65312 13.9609 3.87962 14.0815 4.11222 14.0815C4.22707 14.0815 4.34327 14.0522 4.44987 13.9904C4.77217 13.8039 4.88187 13.3908 4.69487 13.0689C4.50792 12.7466 4.09532 12.6367 3.77302 12.8238Z"
                            fill="#444790"
                          />
                          <path
                            d="M3.87254 10.0071C3.87204 9.6344 3.56974 9.3331 3.19724 9.3335C2.82469 9.33395 2.52329 9.63625 2.52374 10.0084C2.52424 10.381 2.82604 10.6823 3.19819 10.6823H3.19854C3.57124 10.6819 3.87304 10.3795 3.87254 10.0071Z"
                            fill="#444790"
                          />
                          <path
                            d="M10.0032 16.1275C9.63117 16.128 9.32922 16.4298 9.32922 16.8023C9.32972 17.1749 9.63167 17.4768 10.0042 17.4763C10.3767 17.4763 10.6786 17.1739 10.6781 16.8014C10.6782 16.4293 10.376 16.1275 10.0032 16.1275Z"
                            fill="#444790"
                          />
                          <path
                            d="M16.2298 12.8167C15.9076 12.6303 15.4951 12.7405 15.3084 13.0628C15.122 13.3851 15.2322 13.7976 15.5545 13.9842C15.6611 14.0456 15.7773 14.0749 15.8916 14.0749C16.1247 14.0749 16.3512 13.9544 16.4758 13.7381C16.6624 13.4158 16.5521 13.0032 16.2298 12.8167Z"
                            fill="#444790"
                          />
                          <path
                            d="M16.8005 9.30975C16.428 9.3107 16.1266 9.6135 16.1276 9.986C16.1276 9.98975 16.1276 9.9935 16.1276 9.9967C16.1276 9.99815 16.1276 9.99905 16.1276 10C16.1276 10.3725 16.4293 10.6744 16.8019 10.6744C17.1745 10.6744 17.4763 10.3725 17.4763 10C17.4763 9.99765 17.4763 9.99485 17.4763 9.9921C17.4763 9.9893 17.4763 9.986 17.4763 9.9828C17.4755 9.61025 17.173 9.3093 16.8005 9.30975Z"
                            fill="#444790"
                          />
                          <path
                            d="M13.0535 4.68605C13.1595 4.74745 13.2754 4.77625 13.3897 4.77625C13.6228 4.77625 13.8498 4.65535 13.9744 4.4386C14.1605 4.11575 14.0498 3.70325 13.727 3.5172C13.4042 3.3316 12.9916 3.4423 12.806 3.76515C12.6201 4.0879 12.7307 4.5005 13.0535 4.68605Z"
                            fill="#444790"
                          />
                          <path
                            d="M13.0656 15.307C12.7433 15.4935 12.6331 15.906 12.8201 16.2284C12.9452 16.4441 13.1716 16.5651 13.4043 16.5651C13.5192 16.5651 13.635 16.5358 13.7414 16.4741C14.0638 16.2876 14.1736 15.875 13.9871 15.5525C13.8005 15.2302 13.3879 15.12 13.0656 15.307Z"
                            fill="#444790"
                          />
                          <path
                            d="M15.8852 7.26095C16.0006 7.26095 16.1168 7.23115 16.2237 7.1693C16.5457 6.98185 16.655 6.5693 16.4676 6.24745C16.2806 5.9251 15.8675 5.81625 15.5457 6.00325C15.2237 6.1902 15.1144 6.6032 15.3015 6.9251C15.4266 7.14045 15.6526 7.26095 15.8852 7.26095Z"
                            fill="#444790"
                          />
                          <path
                            d="M14.238 10.4728L10.6964 10.2313L10.3429 5.04405C10.3307 4.8656 10.1823 4.72705 10.0033 4.72705C9.82442 4.72705 9.67622 4.8656 9.66392 5.04405L9.31667 10.1372L8.74982 10.0985C8.67422 10.0933 8.59987 10.1198 8.54452 10.1715C8.48927 10.2232 8.45782 10.2956 8.45782 10.3714V11.12C8.45782 11.1959 8.48927 11.2682 8.54452 11.3199C8.59532 11.3673 8.66217 11.3936 8.73127 11.3936C8.73737 11.3936 8.74357 11.3934 8.74982 11.393L9.23332 11.36L9.19842 11.8704C9.19212 11.9645 9.22497 12.0569 9.28927 12.1257C9.35357 12.1946 9.44362 12.2337 9.53792 12.2337H10.4688C10.4692 12.2337 10.4697 12.2337 10.4699 12.2337C10.6577 12.2337 10.81 12.0814 10.81 11.8935C10.81 11.8769 10.7664 11.2552 10.7664 11.2552L14.2381 11.0185C14.3817 11.0087 14.4932 10.8895 14.4932 10.7456C14.4929 10.6019 14.3815 10.4826 14.238 10.4728Z"
                            fill="#444790"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_423_3707">
                            <rect width="20" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>{" "}
                      {selectedDate ? "11 : 8 pm" : "Select Time"}
                    </p>
                  </div>
                  <div className="_divider"></div>
                  <div className="_dates mt-3 d-flex">
                    {slicedEventDates.map((dt) => (
                      <div
                        className={`_date_box ${
                          selectedDate?.id === dt.id ? "_date_box_selected" : ""
                        }`}
                        onClick={() => {
                          if (btnDisabled) {
                            return;
                          }
                          setSelectedDate(dt);
                          setCalendarSelectedDate(dt.id);
                        }}
                        key={dt.id}
                      >
                        <p className="_week_day mt-3">{dt.weekDay}</p>
                        <p className="_month">{dt.month}</p>
                        <div className="_day my-5">
                          <span>{dt.day}</span>
                        </div>
                        <p className="_time">11 : 8 pm</p>
                      </div>
                    ))}
                    <div
                      className="_more_box"
                      onClick={() => {
                        if (btnDisabled) {
                          return;
                        }
                        setCalendarModalShow(true);
                      }}
                    >
                      <p className="_icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="37"
                          height="37"
                          viewBox="0 0 37 37"
                          fill="none"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M12.3333 1.54167C13.1848 1.54167 13.875 2.23191 13.875 3.08334V4.62501H23.125V3.08334C23.125 2.23191 23.8152 1.54167 24.6667 1.54167C25.5181 1.54167 26.2083 2.23191 26.2083 3.08334V4.62505C26.9161 4.62548 27.5329 4.62983 28.0505 4.67213C28.6599 4.72196 29.2656 4.83196 29.8488 5.1291C30.7174 5.57167 31.427 6.27804 31.8712 7.14996C32.1683 7.73301 32.2782 8.33897 32.328 8.94778C32.375 9.52465 32.375 10.2248 32.375 11.0359V25.9649C32.375 26.776 32.375 27.4757 32.328 28.0525C32.2782 28.6611 32.1683 29.2667 31.8712 29.8496C31.4275 30.7206 30.7183 31.4283 29.8488 31.8712C29.2659 32.1683 28.6604 32.2782 28.0517 32.328C27.4751 32.375 26.7752 32.375 25.9641 32.375H11.0359C10.2248 32.375 9.52465 32.375 8.94779 32.328C8.33897 32.2782 7.733 32.1683 7.14996 31.8712C6.27884 31.4273 5.57206 30.7189 5.1291 29.8496C4.83191 29.2662 4.72194 28.6602 4.67213 28.0508C4.62496 27.4734 4.62497 26.7724 4.625 25.9598V11.0409C4.62497 10.2282 4.62496 9.52697 4.67213 8.94935C4.72191 8.33984 4.83183 7.73338 5.1291 7.14996C5.57251 6.27971 6.2797 5.57251 7.14996 5.1291C7.73339 4.83184 8.33983 4.72191 8.94936 4.67213C9.46705 4.62985 10.0841 4.62548 10.7917 4.62505V3.08334C10.7917 2.23191 11.4819 1.54167 12.3333 1.54167ZM9.20036 7.74523C8.78126 7.77946 8.62589 7.83758 8.54976 7.87637C8.25968 8.02418 8.02418 8.25969 7.87638 8.54977C7.83757 8.62589 7.77947 8.78126 7.74523 9.20036C7.71385 9.58458 7.70914 10.0748 7.70844 10.7917H29.2915C29.2909 10.0737 29.2863 9.58322 29.2548 9.19891C29.2206 8.78063 29.1626 8.62563 29.1239 8.54977C28.977 8.26135 28.7408 8.02503 28.449 7.87637C28.3727 7.83744 28.2174 7.77941 27.7992 7.74522C27.3627 7.70954 26.7892 7.70834 25.9003 7.70834H11.1003C10.2115 7.70834 9.63736 7.70954 9.20036 7.74523ZM29.2917 13.875H7.70834V25.9003C7.70834 26.7892 7.70954 27.3629 7.74523 27.7996C7.77944 28.2182 7.8375 28.3735 7.87638 28.4498C8.02462 28.7407 8.26055 28.9766 8.54976 29.1239C8.62563 29.1626 8.78063 29.2206 9.19891 29.2548C9.63511 29.2904 10.2081 29.2917 11.0952 29.2917H25.9048C26.792 29.2917 27.3646 29.2904 27.8004 29.2548C28.2181 29.2206 28.373 29.1628 28.449 29.1239C28.7399 28.9758 28.9766 28.739 29.1239 28.4498C29.1628 28.3738 29.2208 28.2188 29.2548 27.8012C29.2904 27.3654 29.2917 26.7926 29.2917 25.9056V13.875ZM10.7917 18.5C10.7917 17.6485 11.4819 16.9583 12.3333 16.9583H12.3364C12.7515 16.9583 13.1491 17.1258 13.4392 17.4227C13.7293 17.7196 13.8874 18.1211 13.8777 18.5361L13.8776 18.5392C13.868 18.948 13.6964 19.3364 13.4004 19.6186C13.1044 19.9009 12.7084 20.0542 12.2995 20.0443H12.2965C11.4596 20.0243 10.7917 19.3401 10.7917 18.5031V18.5ZM16.9583 18.5C16.9583 17.6485 17.6485 16.9583 18.5 16.9583H18.5031C18.9183 16.9583 19.3159 17.1258 19.6058 17.4227C19.896 17.7196 20.054 18.1211 20.0443 18.5361V18.5392C20.0347 18.948 19.863 19.3364 19.567 19.6186C19.2711 19.9009 18.8751 20.0542 18.4661 20.0443H18.4632C17.6263 20.0243 16.9583 19.3401 16.9583 18.5031V18.5ZM23.125 18.5C23.125 17.6485 23.8152 16.9583 24.6667 16.9583H24.6698C25.5211 16.9583 26.2114 17.6485 26.2114 18.5V18.5031C26.2114 18.9184 26.0438 19.316 25.7468 19.6062C25.4495 19.8963 25.0479 20.0543 24.6328 20.0443H24.6298C23.793 20.0243 23.125 19.3401 23.125 18.5031V18.5ZM10.7917 24.6667C10.7917 23.8152 11.4819 23.125 12.3333 23.125H12.3364C12.7515 23.125 13.1491 23.2924 13.4392 23.5894C13.7293 23.8863 13.8874 24.2877 13.8777 24.7027L13.8776 24.7058C13.868 25.1147 13.6964 25.503 13.4004 25.7853C13.1044 26.0676 12.7084 26.2208 12.2995 26.211H12.2965C11.4596 26.1909 10.7917 25.5067 10.7917 24.6698V24.6667ZM16.9583 24.6667C16.9583 23.8152 17.6485 23.125 18.5 23.125H18.5031C18.9183 23.125 19.3159 23.2924 19.6058 23.5894C19.896 23.8863 20.054 24.2877 20.0443 24.7027V24.7058C20.0347 25.1147 19.863 25.503 19.567 25.7853C19.2711 26.0676 18.8751 26.2208 18.4661 26.211H18.4632C17.6263 26.1909 16.9583 25.5067 16.9583 24.6698V24.6667ZM23.125 24.6667C23.125 23.8152 23.8152 23.125 24.6667 23.125H24.6698C25.0849 23.125 25.4825 23.2924 25.7725 23.5894C26.0627 23.8863 26.2207 24.2877 26.211 24.7027V24.7058C26.2014 25.1147 26.0297 25.503 25.7337 25.7853C25.4378 26.0676 25.0418 26.2208 24.6328 26.211H24.6298C23.793 26.1909 23.125 25.5067 23.125 24.6698V24.6667Z"
                            fill="#444790"
                          />
                        </svg>
                      </p>
                      <p className="_label">
                        More
                        <br />
                        options
                      </p>
                    </div>
                    <Modal
                      size="lg"
                      aria-labelledby="contained-modal-title-vcenter"
                      centered
                      show={calendarModalShow}
                      onHide={() => setCalendarModalShow(false)}
                      className="_calendarModal"
                    >
                      <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                          Select date
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div className="_calendar_box">
                          <Calendar
                            weekDays={weekDays}
                            highlightToday={false}
                            value={calendarSelectedDate}
                            onChange={(i) => {
                              setTempCalendarSelectedDate(
                                `${i.year}/0${i.month.number}/${
                                  i.day < 10 ? `0${i.day}` : i.day
                                }`
                              );
                              console.log(
                                `${i.year}/0${i.month.number}/${
                                  i.day < 10 ? `0${i.day}` : i.day
                                }`
                              );
                            }}
                            minDate="2024/03/09"
                            maxDate="2024/04/07"
                            mapDays={({ date }) => {
                              let props = {};
                              const today = new Date();

                              // Compare the date with today's date
                              if (date.toDate() <= today) {
                                props.disabled = true;
                              }

                              return props;
                            }}
                          />
                        </div>
                      </Modal.Body>
                      <Modal.Footer className="d-flex justify-content-center mb-5 border-top-0">
                        <button
                          className="btn _cancel_btn"
                          onClick={() => {
                            setCalendarModalShow(false);
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          className="btn _confirm_btn"
                          onClick={() => {
                            setCalendarSelectedDate(tempCalendarSelectedDate);
                            const foundDate = eventDates.find(
                              (date) => date.id === tempCalendarSelectedDate
                            );
                            if (foundDate) {
                              setSelectedDate(foundDate);
                              setCalendarModalShow(false);
                            }
                          }}
                        >
                          Confirm
                        </button>
                      </Modal.Footer>
                    </Modal>
                  </div>
                </div>
              </div>
              <div className="inner_description_box mt-5">
                <h1>event description :</h1>
                <div className="home_divider_lg"></div>
                <div className="home_divider_sm"></div>
                <p>{eventData.description}</p>
              </div>
              <div className="inner_media_box mt-5">
                <h1>media :</h1>
                <div className="home_divider_lg"></div>
                <div className="home_divider_sm"></div>
                <div className="img_outter_box">
                  {eventData.media?.map((el, i) => (
                    <div
                      className="img_box"
                      onClick={() => openModal(el)}
                      key={i}
                    >
                      <img src={el} alt="media" />
                    </div>
                  ))}
                </div>
                {isModalOpen && (
                  <ImageModal
                    imageUrl={modalImageUrl}
                    closeModal={closeModal}
                    isModalOpen={isModalOpen}
                  />
                )}
              </div>
              {/* <div className="inner_media_box mt-5">
                <h1>video :</h1>
                <div className="thumbnail">
                  <iframe
                    src="https://www.youtube.com/embed/Kch8n4tcOZQ"
                    allowfullscreen
                  ></iframe>
                </div>
              </div> */}
              <div className="inner_media_box mt-5">
                <h1>location :</h1>
                <div className="home_divider_lg"></div>
                <div className="home_divider_sm"></div>
                <p>{eventData.location}</p>
                <div className="thumbnail">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2484.0036028308073!2d7.447471775863409!3d51.49480137181043!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b919d18c8406b7%3A0x29ec831ed8fde28!2sIm%20Rabenloh%208%2C%2044139%20Dortmund%2C%20Allemagne!5e0!3m2!1sfr!2stn!4v1699533063484!5m2!1sfr!2stn"
                    width="600"
                    height="450"
                    allowfullscreen=""
                    loading="lazy"
                    title="location"
                    referrerpolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
              <div className="inner_media_box mt-5">
                <h1>FAQs :</h1>
                <div className="home_divider_lg"></div>
                <div className="home_divider_sm"></div>
                <Accordian data={eventData.faqs} />
              </div>
            </div>
            {/* <div className={isFixed ? "pFixed" : "right_box"}>
              <div className="header_title">
                <h1>tickets</h1>
              </div>
              <div className="box_body">
                {cartItems.map((item, index) => (
                  <div className="b_one" key={index}>
                    <p>{item.name}:</p>
                    <p id="price">{item.price.toFixed(1)} €</p>
                    <span class="input-wrapper">
                      <button
                        id="decrement"
                        onClick={() => handleDecrement(index)}
                        disabled={item.orderQty == 1}
                      >
                        -
                      </button>
                      <input
                        type="number"
                        value={item.orderQty}
                        id="quantity"
                      />
                      <button
                        id="increment"
                        onClick={() => handleIncrement(index)}
                      >
                        +
                      </button>
                    </span>
                  </div>
                ))}
              </div>
              <div className="box_footer">
                <div className="total_box">
                  <p>total :</p>
                  <p id="t_price">{getTotalPrice(cartItems)} €</p>
                </div>
                <>
                  <button
                    className="btn cart_btn"
                    onClick={handleAddToCart}
                    disabled={btnDisabled}
                  >
                    <svg
                      width="21"
                      height="21"
                      viewBox="0 0 21 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_298_6660)">
                        <path
                          d="M19.9185 4.02741C19.7346 3.79423 19.5 3.6059 19.2326 3.47664C18.9653 3.34738 18.672 3.28057 18.375 3.28125H5.07478L4.57669 1.16222C4.5428 1.01817 4.46122 0.889797 4.34519 0.797949C4.22915 0.7061 4.08548 0.656165 3.9375 0.65625H1.3125C1.13845 0.65625 0.971532 0.725391 0.848461 0.848461C0.72539 0.971532 0.65625 1.13845 0.65625 1.3125C0.65625 1.48655 0.72539 1.65347 0.848461 1.77654C0.971532 1.89961 1.13845 1.96875 1.3125 1.96875H3.41775L5.73759 11.8296C5.23168 11.871 4.76146 12.1067 4.42558 12.4873C4.0897 12.8679 3.91427 13.3638 3.93608 13.8709C3.9579 14.378 4.17527 14.857 4.54259 15.2074C4.90992 15.5577 5.39865 15.7522 5.90625 15.75H17.0625C17.2365 15.75 17.4035 15.6809 17.5265 15.5578C17.6496 15.4347 17.7188 15.2678 17.7188 15.0938C17.7188 14.9197 17.6496 14.7528 17.5265 14.6297C17.4035 14.5066 17.2365 14.4375 17.0625 14.4375H5.90625C5.7322 14.4375 5.56528 14.3684 5.44221 14.2453C5.31914 14.1222 5.25 13.9553 5.25 13.7812C5.25 13.6072 5.31914 13.4403 5.44221 13.3172C5.56528 13.1941 5.7322 13.125 5.90625 13.125H16.9851C17.4291 13.1261 17.8604 12.9766 18.2085 12.7009C18.5565 12.4252 18.8008 12.0396 18.9013 11.6071L20.2919 5.70084C20.3606 5.41185 20.3626 5.11103 20.2979 4.82112C20.2333 4.53121 20.1035 4.2598 19.9185 4.02741Z"
                          fill="white"
                        />
                        <path
                          d="M15.0938 20.3438C16.1811 20.3438 17.0625 19.4623 17.0625 18.375C17.0625 17.2877 16.1811 16.4062 15.0938 16.4062C14.0064 16.4062 13.125 17.2877 13.125 18.375C13.125 19.4623 14.0064 20.3438 15.0938 20.3438Z"
                          fill="white"
                        />
                        <path
                          d="M7.875 20.3438C8.96231 20.3438 9.84375 19.4623 9.84375 18.375C9.84375 17.2877 8.96231 16.4062 7.875 16.4062C6.78769 16.4062 5.90625 17.2877 5.90625 18.375C5.90625 19.4623 6.78769 20.3438 7.875 20.3438Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_298_6660">
                          <rect width="21" height="21" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    Add To Cart
                  </button>
                </>
                <button className="btn validate_btn">Validate My Order</button>
              </div>
            </div> */}
            <div className="right-side">
              <div className={`box_right ${isFixed ? "pFixed" : ""}`}>
                <div className="header_title">
                  <h1>tickets</h1>
                </div>
                <div className="header-date">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8 1C8.55229 1 9 1.44772 9 2V3H15V2C15 1.44772 15.4477 1 16 1C16.5523 1 17 1.44772 17 2V3.00003C17.4591 3.00031 17.8592 3.00313 18.1949 3.03057C18.5902 3.06289 18.9831 3.13424 19.3614 3.32698C19.9248 3.61405 20.3851 4.07224 20.6732 4.63781C20.8659 5.016 20.9372 5.40906 20.9695 5.80396C21 6.17815 21 6.6323 21 7.15839V16.8421C21 17.3682 21 17.8221 20.9695 18.1962C20.9372 18.591 20.8659 18.9838 20.6732 19.3619C20.3854 19.9269 19.9254 20.3859 19.3614 20.6732C18.9833 20.8659 18.5905 20.9372 18.1957 20.9695C17.8217 21 17.3677 21 16.8416 21H7.15839C6.6323 21 6.17815 21 5.80397 20.9695C5.40906 20.9372 5.016 20.8659 4.63781 20.6732C4.07276 20.3853 3.61431 19.9258 3.32698 19.3619C3.13421 18.9835 3.06288 18.5904 3.03057 18.1951C2.99997 17.8206 2.99998 17.3659 3 16.8388V7.16168C2.99998 6.6345 2.99997 6.17965 3.03057 5.80498C3.06286 5.40962 3.13416 5.01624 3.32698 4.63781C3.6146 4.07332 4.07332 3.6146 4.63781 3.32698C5.01625 3.13416 5.40962 3.06286 5.80499 3.03057C6.14079 3.00314 6.54102 3.00031 7 3.00003V2C7 1.44772 7.44772 1 8 1ZM5.9678 5.02393C5.69595 5.04613 5.59517 5.08383 5.54579 5.10899C5.35763 5.20487 5.20487 5.35763 5.109 5.54579C5.08383 5.59517 5.04614 5.69595 5.02393 5.9678C5.00358 6.21702 5.00052 6.53498 5.00007 7H18.9999C18.9995 6.53429 18.9965 6.21614 18.9761 5.96686C18.9539 5.69554 18.9163 5.595 18.8912 5.54579C18.7959 5.35871 18.6427 5.20542 18.4534 5.10899C18.4039 5.08374 18.3032 5.0461 18.0319 5.02392C17.7488 5.00078 17.3768 5 16.8002 5H7.2002C6.62365 5 6.25126 5.00078 5.9678 5.02393ZM19 9H5V16.8002C5 17.3768 5.00078 17.7489 5.02393 18.0322C5.04612 18.3037 5.08378 18.4044 5.109 18.4539C5.20516 18.6426 5.35819 18.7956 5.54579 18.8912C5.595 18.9163 5.69554 18.9539 5.96686 18.9761C6.2498 18.9992 6.62146 19 7.19691 19H16.8031C17.3786 19 17.75 18.9992 18.0327 18.9761C18.3036 18.9539 18.4041 18.9164 18.4534 18.8912C18.6421 18.7951 18.7956 18.6415 18.8912 18.4539C18.9164 18.4046 18.954 18.3041 18.9761 18.0332C18.9992 17.7505 19 17.379 19 16.8036V9ZM7 12C7 11.4477 7.44772 11 8 11H8.002C8.27127 11 8.52916 11.1086 8.71732 11.3012C8.90548 11.4938 9.00802 11.7542 9.00173 12.0234L9.00168 12.0254C8.99548 12.2906 8.88414 12.5425 8.69215 12.7256C8.50016 12.9087 8.24327 13.0081 7.97804 13.0017H7.97608C7.43327 12.9887 7 12.5449 7 12.002V12ZM11 12C11 11.4477 11.4477 11 12 11H12.002C12.2713 11 12.5292 11.1086 12.7173 11.3012C12.9055 11.4938 13.008 11.7542 13.0017 12.0234V12.0254C12.9955 12.2906 12.8841 12.5425 12.6921 12.7256C12.5002 12.9087 12.2433 13.0081 11.978 13.0017H11.9761C11.4333 12.9887 11 12.5449 11 12.002V12ZM15 12C15 11.4477 15.4477 11 16 11H16.002C16.5542 11 17.002 11.4477 17.002 12V12.002C17.002 12.2714 16.8933 12.5293 16.7006 12.7175C16.5078 12.9057 16.2473 13.0082 15.978 13.0017H15.9761C15.4333 12.9887 15 12.5449 15 12.002V12ZM7 16C7 15.4477 7.44772 15 8 15H8.002C8.27127 15 8.52916 15.1086 8.71732 15.3012C8.90548 15.4938 9.00802 15.7542 9.00173 16.0234L9.00168 16.0254C8.99548 16.2906 8.88414 16.5425 8.69215 16.7256C8.50016 16.9087 8.24327 17.0081 7.97804 17.0017H7.97608C7.43327 16.9887 7 16.5449 7 16.002V16ZM11 16C11 15.4477 11.4477 15 12 15H12.002C12.2713 15 12.5292 15.1086 12.7173 15.3012C12.9055 15.4938 13.008 15.7542 13.0017 16.0234V16.0254C12.9955 16.2906 12.8841 16.5425 12.6921 16.7256C12.5002 16.9087 12.2433 17.0081 11.978 17.0017H11.9761C11.4333 16.9887 11 16.5449 11 16.002V16ZM15 16C15 15.4477 15.4477 15 16 15H16.002C16.2713 15 16.5292 15.1086 16.7173 15.3012C16.9055 15.4938 17.008 15.7542 17.0017 16.0234V16.0254C16.9955 16.2906 16.8841 16.5425 16.6921 16.7256C16.5002 16.9087 16.2433 17.0081 15.978 17.0017H15.9761C15.4333 16.9887 15 16.5449 15 16.002V16Z"
                      fill="#57BABC"
                    />
                  </svg>
                  <span>
                    {selectedDate ? (
                      <>
                        {selectedDate?.weekDay}, {selectedDate?.month}{" "}
                        {selectedDate?.day} / 11 : 8 pm
                      </>
                    ) : (
                      ""
                    )}
                  </span>
                </div>
                <div className="box_body">
                  {cartItems.map((item, index) => (
                    <div className="b_one" key={index}>
                      <p className="col text-start">{item.name}:</p>
                      <p id="price" className="col">
                        {item.price.toFixed(1)} €
                      </p>
                      <div class="col input-wrapper">
                        <button
                          onClick={() => handleDecrement(index)}
                          // eslint-disable-next-line
                          disabled={item.orderQty == 0}
                        >
                          -
                        </button>
                        <span>{item.orderQty}</span>
                        <button onClick={() => handleIncrement(index)}>
                          +
                        </button>
                        {/* <span className="input-wrapper">
                      <button
                        id="decrement"
                        onClick={() => handleDecrement(index)}
                        disabled={item.orderQty == 1}
                      >
                        -
                      </button>
                      <input
                        type="number"
                        value={item.orderQty}
                        id="quantity"
                      />
                      <button
                        id="increment"
                        onClick={() => handleIncrement(index)}
                      >
                        +
                      </button>
                      </span> */}
                      </div>
                    </div>
                  ))}
                </div>
                <div className="box_footer">
                  <div className="total_box">
                    <p>total :</p>
                    <p id="t_price">{getTotalPrice(cartItems)} €</p>
                  </div>
                  <>
                    <button
                      className="btn cart_btn"
                      onClick={handleAddToCart}
                      disabled={btnDisabled}
                    >
                      <svg
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_298_6660)">
                          <path
                            d="M19.9185 4.02741C19.7346 3.79423 19.5 3.6059 19.2326 3.47664C18.9653 3.34738 18.672 3.28057 18.375 3.28125H5.07478L4.57669 1.16222C4.5428 1.01817 4.46122 0.889797 4.34519 0.797949C4.22915 0.7061 4.08548 0.656165 3.9375 0.65625H1.3125C1.13845 0.65625 0.971532 0.725391 0.848461 0.848461C0.72539 0.971532 0.65625 1.13845 0.65625 1.3125C0.65625 1.48655 0.72539 1.65347 0.848461 1.77654C0.971532 1.89961 1.13845 1.96875 1.3125 1.96875H3.41775L5.73759 11.8296C5.23168 11.871 4.76146 12.1067 4.42558 12.4873C4.0897 12.8679 3.91427 13.3638 3.93608 13.8709C3.9579 14.378 4.17527 14.857 4.54259 15.2074C4.90992 15.5577 5.39865 15.7522 5.90625 15.75H17.0625C17.2365 15.75 17.4035 15.6809 17.5265 15.5578C17.6496 15.4347 17.7188 15.2678 17.7188 15.0938C17.7188 14.9197 17.6496 14.7528 17.5265 14.6297C17.4035 14.5066 17.2365 14.4375 17.0625 14.4375H5.90625C5.7322 14.4375 5.56528 14.3684 5.44221 14.2453C5.31914 14.1222 5.25 13.9553 5.25 13.7812C5.25 13.6072 5.31914 13.4403 5.44221 13.3172C5.56528 13.1941 5.7322 13.125 5.90625 13.125H16.9851C17.4291 13.1261 17.8604 12.9766 18.2085 12.7009C18.5565 12.4252 18.8008 12.0396 18.9013 11.6071L20.2919 5.70084C20.3606 5.41185 20.3626 5.11103 20.2979 4.82112C20.2333 4.53121 20.1035 4.2598 19.9185 4.02741Z"
                            fill="white"
                          />
                          <path
                            d="M15.0938 20.3438C16.1811 20.3438 17.0625 19.4623 17.0625 18.375C17.0625 17.2877 16.1811 16.4062 15.0938 16.4062C14.0064 16.4062 13.125 17.2877 13.125 18.375C13.125 19.4623 14.0064 20.3438 15.0938 20.3438Z"
                            fill="white"
                          />
                          <path
                            d="M7.875 20.3438C8.96231 20.3438 9.84375 19.4623 9.84375 18.375C9.84375 17.2877 8.96231 16.4062 7.875 16.4062C6.78769 16.4062 5.90625 17.2877 5.90625 18.375C5.90625 19.4623 6.78769 20.3438 7.875 20.3438Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_298_6660">
                            <rect width="21" height="21" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      Add To Cart
                    </button>
                  </>
                  <button className="btn validate_btn">
                    Validate My Order
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mobile-right_box">
          <div className="mobile-header">
            <span>tickets</span>
            <button onClick={() => setIsMobile(true)}>buy</button>
            <MobileOrder
              isMobile={isMobile}
              setIsMobile={setIsMobile}
              eventData={eventData}
              cartItems={cartItems}
              handleIncrement={handleIncrement}
              handleDecrement={handleDecrement}
              getTotalPrice={getTotalPrice}
              setBtnDisabled={setBtnDisabled}
              btnDisabled={btnDisabled}
              selectedDate={selectedDate}
            />
          </div>
        </div>
      </>
    )
  );
}
